export const apiHost = {
    baseURLDaqi: "https://dev-ecs-api.daqi.in/api/",
    baseURL: "https://dev-ecs-mis.daqi.in/",
    // baseURLDaqi: "https://prod-ecs-api.daqi.in/api/",
    // baseURL: "https://prod-ecs-mis.daqi.in/"
};